const navigation = () => {
  const btn = document.querySelector(".js-hamburger");
  const header = document.querySelector(".js-header");
  const nav = document.querySelector(".js-navigation");

  const menuToggle = () => {
    btn.classList.toggle("open");
    nav.classList.toggle("open");
    header.classList.toggle("open");
  };
  btn.addEventListener("click", menuToggle);
};

export default navigation;
